import { render, staticRenderFns } from "./OrgPersonnelIcon.vue?vue&type=template&id=20969834"
import script from "./OrgPersonnelIcon.vue?vue&type=script&lang=js"
export * from "./OrgPersonnelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports